<template>
  <div class="features__container">
    <div class="features-row">
      <div data-scroll data-scroll-speed="0.8" class="features-item">
        <h4 class="features-item__title">
          <span class="features-item__title-number">01</span>
          <span class="features-item__title-txt">
            セット力×持続力が高い独自処方
          </span>
        </h4>
        <p class="features-item__desc">
          オーシャントリコのヘアワックス史上最強のセット力を実現。<br />
          硬い髪も、短い髪も自由自在にセット可能！
        </p>
      </div>
      <div
        data-scroll
        data-scroll-speed="0.8"
        data-scroll-delay="0.05"
        class="features-item"
      >
        <h4 class="features-item__title">
          <span class="features-item__title-number">02</span>
          <span class="features-item__title-txt">
            ハードタイプなのに伸びが良い<br />テクスチャ
          </span>
        </h4>
        <p class="features-item__desc">
          テクスチャも硬めのハードタイプ。<br />
          「ハードタイプは伸びが悪い」というイメージを崩し、
          セット中は乾かずに伸びの良さを実現。
        </p>
      </div>
    </div>

    <div class="features-row">
      <div data-scroll data-scroll-speed="0.8" class="features-item">
        <h4 class="features-item__title">
          <span class="features-item__title-number">03</span>
          <span class="features-item__title-txt">
            実は究極のこだわり！洗い流しやすさ
          </span>
        </h4>
        <p class="features-item__desc">
          ヘアワックスを使うと、なかなか落ちずにシャンプーの手間がかかる・・・<br />
          オーシャントリコは、洗い流しやすさにもこだわって作られた処方だからお湯とシャンプーで、するすると洗い流すことが可能。<br />
          セット力との両立が、開発で苦労したポイントでした。
        </p>
      </div>
      <div
        data-scroll
        data-scroll-speed="0.8"
        data-scroll-delay="0.05"
        class="features-item"
      >
        <h4 class="features-item__title">
          <span class="features-item__title-number">04</span>
          <span class="features-item__title-txt">
            ワックスでも“いい香り”を実現！
          </span>
        </h4>
        <p class="features-item__desc">
          雑誌や日本フレグランス大賞など、18冠受賞のブランド「ライジングウェーブ」の一番人気の香り
          「ライジングウェーブ フリー（ライトブルー）」の香りを採用。<br />
          セット中も、セット後も、髪からほんのりいい香り。
        </p>
      </div>
    </div>

    <div class="features__product-image-wrap">
      <picture>
        <source type="image/webp" srcset="@/assets/bottle.webp" />
        <img
          ref="bottle"
          data-scroll
          data-scroll-speed="0.5"
          data-scroll-delay="0.5"
          src="@/assets/bottle.png"
          alt=""
        />
      </picture>

      <span class="circle">
        <span
          data-scroll
          data-scroll-speed="1"
          data-scroll-delay="0.05"
          class="circle-in"
        ></span>
      </span>
      <span class="circle">
        <span
          data-scroll
          data-scroll-speed="1"
          data-scroll-delay="0.25"
          class="circle-in"
        ></span>
      </span>
      <span class="circle">
        <span
          data-scroll
          data-scroll-speed="1"
          data-scroll-delay="0.5"
          class="circle-in"
        ></span>
      </span>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  async mounted() {
    this.$nextTick(async () => {
      gsap.set(this.$el.querySelectorAll('.circle'), {
        scale: 0
      })
      gsap.set(this.$refs.bottle, {
        opacity: 0
      })
      const tl = gsap.timeline({
        onStart: () => {
          gsap.set(this.$el.querySelectorAll('.circle'), {
            scale: 0
          })
        },
        paused: true
      })
      tl.to(this.$el.querySelectorAll('.circle'), {
        scale: 1,
        duration: 1.4,
        stagger: 0.054,
        ease: 'elastic.out(1, 0.5)'
      })
      tl.to(
        this.$refs.bottle,
        {
          opacity: 1,
          duration: 0.9,
          ease: 'Power3.easeOut'
        },
        '-=0.8'
      )

      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              tl.play()
              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.5 }
      )

      observer.observe(this.$el)
    })
  }
}
</script>

<style lang="scss" scoped>
.features {
  &__container {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 12rem 0 0;

    .features-row {
      display: flex;
      justify-content: space-between;
      @media screen and (max-width: $breakpoint-mobile) {
        flex-direction: column;
      }

      &:nth-child(2) {
        @media screen and (max-width: $breakpoint-mobile) {
          padding: 36rem 0 0;
        }
        .features-item {
          margin: 0;
        }
      }
    }

    .features-item {
      width: 41rem;
      text-align: left;
      margin: 0 0 10rem;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        padding: 0 0 6rem;
        margin: 0;
      }

      &__title {
        position: relative;
        @media screen and (max-width: $breakpoint-mobile) {
          margin: 0 0 0 -1rem;
        }
      }

      &__title-number {
        position: absolute;
        top: -10rem;
        left: -4rem;
        font-size: 10rem;
        color: var(--main-color);
        opacity: 0.2;
        font-weight: 800;
        @media screen and (max-width: $breakpoint-mobile) {
          top: -8rem;
          left: -1rem;
          opacity: 0.1;
          font-size: 8rem;
        }
      }

      &__title-txt {
        position: relative;
        display: inline-block;
        color: #fff;
        line-height: 1.3;
        font-size: 1.5rem;
        padding: 1.3rem 4rem;
        text-indent: 1em;
        z-index: 0;

        &:after {
          position: absolute;
          top: 0;
          display: block;
          content: '';
          width: 100%;
          height: 100%;
          background: var(--main-color);
          transform: skew(-30deg, 0deg);
          transform-origin: 0 0;
          z-index: -9;
        }
      }

      &__desc {
        font-size: 1.3rem;
        font-weight: 600;
        padding: 2rem 2rem 0 4rem;
        @media screen and (max-width: $breakpoint-mobile) {
          padding: 2rem 2rem 0;
        }
      }
    }
  }

  &__product-image-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media screen and (max-width: $breakpoint-mobile) {
      top: calc(50% - 2rem);
    }
    img {
      width: 16rem;
      z-index: 9;
    }

    .circle {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      border-radius: 50%;

      .circle-in {
        display: block;
        border-radius: 50%;
      }

      &:nth-of-type(1) {
        .circle-in {
          width: 26rem;
          height: 26rem;
          background: var(--main-color);
        }
        z-index: -9;
      }
      &:nth-of-type(2) {
        .circle-in {
          width: 42rem;
          height: 42rem;
          border: 1px solid var(--main-color);
        }

        z-index: -9;
        opacity: 0.3;
      }
      &:nth-of-type(3) {
        .circle-in {
          width: 52rem;
          height: 52rem;
          border: 1px solid var(--main-color);
        }

        z-index: -9;
        opacity: 0.2;
      }
    }
  }
}
</style>
